import {
  makeStyles,
  Tab as MaterialTab,
  Tabs as MaterialTabs,
  withStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import { colors } from 'design-system';
import React from 'react';
import { getTitleByOptionByPlanDescription } from 'src/functions/individualOptionHelpers';

type NumberTabs = {
  lenght: number;
};

const useStyles = makeStyles(() => ({
  selectedTab: {
    fontWeight: 800,
    backgroundColor: '#F5FAFF',
    borderRadius: '10px 10px 0px 0px',
  },
  tabWidht: (params: NumberTabs) => ({
    width: `${100 / params.lenght}%`,
  }),
}));

const CustomTabs = withStyles({
  root: {
    height: 50,
  },
  indicator: {
    backgroundColor: colors.bright_turquoise,
    height: 4,
  },
})(MaterialTabs);

const CustomTab = withStyles({
  root: {
    color: colors.madison,
    textTransform: 'none',
    fontSize: 12,
    fontWeight: 700,
    marginTop: 8,
  },
})(MaterialTab);

export type TabsProps = {
  /** The tab offset to display */
  currentTab?: number;
  /** An array with the tab names */
  tabs: { label: string; index: number }[];
  /** Called when the tab changes */
  onTabChange: (tabOffset: number) => void;
  // backgroundColor of the Tabs
  backgroundColor?: string;
  moneyType: string;
  disabled?: boolean;
};

const Tabs = ({
  tabs,
  onTabChange,
  currentTab = 0,
  backgroundColor,
  moneyType,
  disabled,
}: TabsProps): JSX.Element => {
  const classes = useStyles({ lenght: tabs.length });

  function handleTabChange(
    _event: React.ChangeEvent<{}>,
    newValue: number,
  ): void {
    onTabChange(newValue);
  }

  return (
    <CustomTabs
      value={currentTab}
      style={{ backgroundColor, width: '100%' }}
      onChange={handleTabChange}
      disabled={disabled}
    >
      {tabs.map(
        (tab: { label: string; index: number }): React.ReactElement =>
          tab.index === currentTab ? (
            <CustomTab
              key={tab.index}
              className={clsx(classes.selectedTab, classes.tabWidht)}
              label={getTitleByOptionByPlanDescription(tab.label, moneyType)}
              disabled={disabled}
            />
          ) : (
            <CustomTab
              key={tab.index}
              label={getTitleByOptionByPlanDescription(tab.label, moneyType)}
              className={classes.tabWidht}
              disabled={disabled}
            />
          ),
      )}
    </CustomTabs>
  );
};

export default Tabs;
